import { Box, IconButton } from '@mui/material';
import { ATSAutomationListTestIds } from 'data-testids/ATS';
import { ReactComponent as EditIcon } from 'assets/icons/icon_edit.svg';
import { useRef } from 'react';

interface EditAutomationsButtonProps {
  questionId: number;
  onEdit: (questionId: number) => void;
}

export const EditAutomationsButton: React.FC<EditAutomationsButtonProps> = ({
  questionId,
  onEdit,
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  return (
    <Box>
      <IconButton
        ref={buttonRef}
        onMouseDown={(event) => {
          event.stopPropagation();
          event.preventDefault();
        }}
        onPointerDown={(event) => {
          event.stopPropagation();
          event.preventDefault();
        }}
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          onEdit(questionId);
        }}
        data-testid={`${ATSAutomationListTestIds.EDIT_AUTOMATIONS_BUTTON}-${questionId}`}
      >
        <EditIcon />
      </IconButton>
    </Box>
  );
};
